"use client";

import Image from "next/image";
import style from "./legitScriptsCeritified.module.scss";

export default function LegitScriptsCeritified({}: LegitScriptsCeritifiedProps) {
  return (
    <div className={style.legitScriptsCertified}>
      <div>
        <Image
          src="https://static.legitscript.com/seals/3674843.png"
          alt="Legitscripts Ceritfied"
          unoptimized
          width={55}
          height={60}
        />
      </div>
      <div className={style.text}>
        <div>
          <strong>We&apos;re LegitScript Certified</strong>
        </div>
        <div>
          <span>Certified Healthcare Merchant Site</span>
        </div>
      </div>
    </div>
  );
}

export type LegitScriptsCeritifiedProps = Record<string, never>;
